import {SVG} from "./svg";

type Route = {
  path: string;
  title: string;
  icon?: string;
  activeIcon?: string;
  children?: Route[];
  defaultPath?: string;
}
type Routes = {
  baseUrl: string;
  routes: Route[];
}

export const routes:Routes = {
  baseUrl: "manage-program",
  routes: [
    {
      path: "manage-program",
      title: "프로그램 관리",
      icon: SVG.nav_manage_program,
      activeIcon: SVG.nav_manage_program_active,
    },
    {
      path: "manage-club-join",
      defaultPath: "manage-club-join/activePaid",
      title: "클럽 가입 신청 관리",
      icon: SVG.nav_manage_club_join,
      activeIcon: SVG.nav_manage_club_join_active,
      children: [
        {
          path: "activePaid",
          title: "활성 클럽 (결제 완료)"
        },
        {
          path: "activeUnpaid",
          title: "활성 클럽 (결제 대기)"
        },
        {
          path: "inactive",
          title: "비활성 클럽"
        }
      ]
    },
    {
      path: "search-info",
      defaultPath: "search-info/club",
      title: "정보 조회",
      icon: SVG.nav_search_info,
      activeIcon: SVG.nav_search_info_active,
      children: [
        {
          path: "club",
          title: "클럽 조회"
        },
        {
          path: "player",
          title: "선수 조회"
        },
      ]
    }
  ]
}